// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"f2665ff7","170":"02b39e45","237":"d7e6926f","264":"e0a343f1","295":"3d1eaf71","302":"629cd342","453":"39e6e5e6","518":"b581b631","590":"20096095","783":"1b517f94"}[chunkId] + ".chunk.js";
};